"use client";

import Link from "next/link";
import { MapPin, Mail, Phone } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#f5f0f0] text-[#3E2F2F] px-6 pt-12 pb-8 shadow-lg rounded-t-xl border-t-4 border-[#A65D5D]">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 sm:px-4">
        {/* Explore Section */}
        <div className="flex flex-col items-start  md:ml-15 justify-start ">
          <div className="  md:mx-auto p-2">

          <h3 className="text-2xl font-semibold text-[#A65D5D]  mb-4 border-b-2 border-[#A65D5D] pb-2 w-fit">
            Explore
          </h3>
          <ul className="space-y-3 text-[#6B4F4F] font-sans text-base sm:text-lg font-semibold">
            <li>
              <Link href="/" className="hover:text-[#A65D5D] transition duration-300">
                Home
              </Link>
            </li>
            <li>
              <Link href="/#about" className="hover:text-[#A65D5D] transition duration-300">
                About
              </Link>
            </li>
            <li>
              <Link href="/gallery" className="hover:text-[#A65D5D] transition duration-300">
                Portfolio
              </Link>
            </li>
            <li>
              <Link href="/#services" className="hover:text-[#A65D5D] transition duration-300">
                Services
              </Link>
            </li>
           
          </ul>
        </div>
          </div>

        {/* Divider (Hidden on mobile) */}
        <div className="hidden md:flex justify-center">
          <div className="border-l-2 border-[#A65D5D]/40 h-full" />
        </div>

        {/* Contact Us Section */}
        <div className="flex flex-col items-start">
          <h3 className="text-2xl font-semibold text-[#A65D5D] mb-4 border-b-2 border-[#A65D5D] pb-2 w-fit">
            Contact Us
          </h3>
          <ul className="space-y-4 text-[#6B4F4F] font-sans text-base sm:text-md font-semibold">
            <li className="flex items-start gap-3">
  <a
    href="https://www.google.com/maps?sca_esv=5cbb6f2e087ee285&gs_lp=Egxnd3Mtd2l6LXNlcnAiEmRlc2lnbiBub29rIGNoYW5kaSoCCAAyBBAhGBUyBRAhGJ8FSOAaUKgDWNUNcAF4AZABAJgBuwGgAZYIqgEDMC43uAEDyAEA-AEBmAIIoAK6CMICChAAGLADGNYEGEfCAgUQABiABMICBhAAGBYYHsICCBAAGBYYChgewgIHEAAYgAQYDcICBhAAGA0YHsICCBAAGAUYDRgewgIIEAAYCBgNGB6YAwCIBgGQBgKSBwMxLjegB-srsgcDMC43uAe2CMIHBTAuMy41yAcb&um=1&ie=UTF-8&fb=1&gl=in&sa=X&geocode=KQkQzFoA6Q85Mc7RO2200cBj&daddr=2nd+LEVEL,+EMAAR+MGF+-+The+Views,+CENTRAL+PLAZA,+CPM+09,+Emaar+MGF+Mohali+Sector+105,+Sahibzada+Ajit+Singh+Nagar,+Punjab+140306"
    target="_blank"
    rel="noopener noreferrer"
    className="flex items-start gap-3"
  >
    <MapPin className="text-[#A65D5D] shrink-0 mt-1" size={20} />
    <span>
      CPM 09, Second Floor, Central Plaza EMAAR MGF, Sector-105, Mohali, Punjab, India.
    </span>
  </a>
</li>

            <li className="flex items-start gap-3">
              <Mail className="text-[#A65D5D] shrink-0 mt-1" size={20} />
              <a
                href="mailto:designnook.id@gmail.com"
                className="hover:text-[#A65D5D] transition duration-300 break-all"
              >
                designook.id@gmail.com
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="text-[#A65D5D] shrink-0 mt-1" size={20} />
              <div className="flex flex-col">
                <a href="tel:+917017208147" className="hover:text-[#A65D5D] transition duration-300">
                  +91 70172-08147
                </a>
                <a href="tel:+917341109977" className="hover:text-[#A65D5D] transition duration-300 mt-1">
                  +91 73411-09977
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="mt-12 border-t-2 border-[#A65D5D]/30 pt-6 text-center text-xs text-[#A39191] tracking-wide font-semibold uppercase select-none">
        &copy; {new Date().getFullYear()} Design Nook. Crafted with intention. All rights reserved.
      </div>
      
    </footer>
  );
};

export default Footer;
